<template>
	<div class="row offset-16">
		<div
			:class="{
				'col-md-6 col-lg-4': client.style === 'modern',
				'col-12': client.style === 'classic',
			}"
			v-for="(item, index) in list"
			:key="index"
		>
			<ProductsItemClassic
				v-if="client.style === 'classic'"
				:item="item"
				:selectProduct="selectProduct"
			/>

			<ProductsItem
				v-else
				:item="item"
				@click.native="selectProduct(item)"
			/>
		</div>
	</div>
</template>

<script>
import ProductsItemClassic from './ProductsItemClassic.vue'
import ProductsItem from './ProductsItem.vue'

export default {
	props: [
		'list',
		'selectProduct',
	],

	components: {
		ProductsItemClassic,
		ProductsItem,
	},
}
</script>

<style lang="scss" scoped></style>
